module.exports = __webpack_public_path__ + "assets/img/title-a6c74c69.png";